/* eslint-disable no-unused-vars */
import {
  Button,
  Col,
  DatePicker,
  Input,
  Modal,
  Row,
  Table,
  Typography,
  notification,
} from "antd";

import React, { useEffect, useRef, useState } from "react";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import * as XLSX from "xlsx-js-style";
import moment from "moment";
import { BiExport, BiImport } from "react-icons/bi";
import SelectOption from "../../pos/components/SelectOption";
import { useHttp } from "../../../../hooks/http";
import { getToken, URL_API } from "../../../../utils";
import axios from "axios";

const { Text } = Typography;
const { Search } = Input;
const limit = 30;
const pageSize = 20;

const Index = () => {
  const [memberTypeFilter, setMemberTypeFilter] = useState("");
  const [page, setPage] = useState(1);
  const [importPage, setImportPage] = useState(1);
  const [date_from, setDateFrom] = useState(moment());
  const [date_to, setDateTo] = useState(moment());
  const [search, setSearch] = useState("");
  const [modalStatusPage, setModalStatusPage] = useState(1);
  const [sheetName, setSheetName] = useState("");
  const [fileName, setFileName] = useState("");
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [resImportStatusData, setResImportStatusData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [previewImportData, setPreviewImportData] = useState([]);
  const fileInputRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const source = axios.CancelToken.source();
  const memberTypeOptions = [
    { value: "", text: "ทั้งหมด" },
    { value: "Distributor", text: "นักธุรกิจ" },
    { value: "Member", text: "VIP MEMBER" },
  ];

  const downloadTemplate = () => {
    let excelData = [
      ["#", "รหัสสมาชิก", "ชื่อ นามสกุล", "รายละเอียด", "คะแนน RP"],
    ];

    var wscols = [
      { wch: 10 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
    ];

    const centerStyles = {
      alignment: {
        vertical: "center",
        horizontal: "center",
      },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
      },
      fill: { fgColor: { rgb: "E9E9E9" } },
    };

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(excelData);
    ws["!cols"] = wscols;

    ["A1", "B1", "C1", "D1", "E1"].forEach((cell) => {
      ws[cell].s = centerStyles;
    });

    XLSX.utils.book_append_sheet(wb, ws, "template-add-rp");
    XLSX.writeFile(wb, "template-add-rp.xlsx");
  };

  const importTemplate = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      const json = XLSX.utils.sheet_to_json(worksheet, {
        range: 1, // ข้าม header แถวแรก
        header: [
          "row_id",
          "partner_code",
          "partner_name",
          "description",
          "point",
        ],
        defval: "",
      });

      const duplicates = new Set();
      const seenKeys = new Set();
      const overLengthDescriptions = [];

      json.forEach((item) => {
        const compositeKey = `${item.partner_code}|${item.description}`; // 🔑 รวม key+description
        const partnerOnlyKey = item.partner_code;

        // ถ้ามีรหัส partner_code ซ้ำโดยมี description เหมือนกัน → นับซ้ำ
        if (seenKeys.has(compositeKey)) {
          duplicates.add(partnerOnlyKey);
        } else {
          seenKeys.add(compositeKey);
        }

        if (item.description.length > 50) {
          overLengthDescriptions.push(item);
        }
      });

      // แสดง warning ถ้ามีปัญหา
      if (duplicates.size > 0 || overLengthDescriptions.length > 0) {
        if (duplicates.size > 0) {
          const duplicateList = [...duplicates].join(", ");
          Modal.warning({
            title: "รหัสพนักงานซ้ำ",
            content: `ตรวจพบรหัสพนักงานซ้ำในรายละเอียดเดียวกัน : ${duplicateList} กรุณาแก้ไขก่อนนำเข้าข้อมูล`,
          });
        }

        if (overLengthDescriptions.length > 0) {
          const overLimitList = overLengthDescriptions
            .slice(0, 5)
            .map((item) => item.partner_code)
            .join(", ");
          const moreCount = overLengthDescriptions.length - 5;

          Modal.warning({
            title: "รายละเอียดเกิน 50 ตัวอักษร",
            content: `พบรายละเอียดที่ยาวเกินกำหนดในรหัสพนักงาน: ${overLimitList}${
              moreCount > 0 ? ` และอีก ${moreCount} รายการ` : ""
            } กรุณาปรับให้ไม่เกิน 50 ตัวอักษรก่อนนำเข้า`,
          });
        }

        return;
      }
      setSheetName(firstSheetName); // 👉 เก็บชื่อชีต
      setFileName(file.name); // 👉 เก็บชื่อไฟล์
      setPreviewImportData(json);
      setImportPage(1); // reset page
      setPreviewModalVisible(true);
    };

    reader.readAsArrayBuffer(file);
    event.target.value = null;
  };

  const exportFailList = () => {
    const failData = resImportStatusData.filter(
      (item) => item.status?.toLowerCase() === "failed"
    );

    if (failData.length === 0) {
      notification.warning({
        message: "ไม่มีข้อมูลที่ล้มเหลว",
        description: "ไม่พบรายการที่มีสถานะ 'fail'",
      });
      return;
    }

    const headers = [
      "#",
      "รหัสสมาชิก",
      "ชื่อ - นามสกุล",
      "รายละเอียด",
      "คะแนน RP",
    ];
    const rows = failData.map((item, index) => [
      index + 1,
      item.partner_code,
      item.partner_name,
      item.description,
      item.point,
    ]);

    const wsData = [headers, ...rows];

    var wscols = [
      { wch: 10 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
    ];

    const centerStyles = {
      alignment: {
        vertical: "center",
        horizontal: "center",
      },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
      },
      fill: { fgColor: { rgb: "E9E9E9" } },
    };

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws["!cols"] = wscols;
    ["A1", "B1", "C1", "D1", "E1"].forEach((cell) => {
      ws[cell].s = centerStyles;
    });

    XLSX.utils.book_append_sheet(wb, ws, "ADD RP Fail List");
    XLSX.writeFile(wb, "ADD-RP-fail-list.xlsx");
  };

  const [loading, data, error, reload] = useHttp(
    {
      url: `${URL_API}/point/rp/addrp`,
      token: true,
      params: {
        limit,
        offset: limit * (page - 1),
        query: search,
        date_from: date_from ? moment(date_from).format("YYYY-MM-DD") : null,
        date_to: date_to ? moment(date_to).format("YYYY-MM-DD") : null,
        member_type_filter: memberTypeFilter,
      },
      initialLoad: true,
    },
    [search, date_from, date_to, memberTypeFilter]
  );

  return (
    <Panel>
      <PanelHeader>ADD RP</PanelHeader>
      <PanelBody>
        <input
          type="file"
          accept=".xlsx"
          ref={fileInputRef}
          onChange={importTemplate}
          style={{ display: "none" }}
        />

        <Row gutter={12} type="flex" className="align-items-center mb-3">
          <Col span={4}>
            <Search
              placeholder="ค้นหาจาก รหัสสมาชิก"
              onSearch={(value) => setSearch(value)}
              allowClear
            />
          </Col>
          <Col>
            <Text strong>ประเภทสมาชิก</Text>
          </Col>
          <Col span={4}>
            <SelectOption
              className="w-100"
              defaultValue={memberTypeFilter}
              options={memberTypeOptions}
              onChange={(e) => setMemberTypeFilter(e)}
            />
          </Col>
          <Col span={2} className="text-right">
            <Typography.Text strong className="text-nowrap">
              วันที่คะแนนเข้าระบบ
            </Typography.Text>
          </Col>
          <Col span={6}>
            <DatePicker.RangePicker
              className="w-100"
              placeholder={["วันที่เริ่มต้น", "วันที่สิ้นสุด"]}
              format="DD/MM/YYYY"
              value={[date_from, date_to]}
              onChange={(e) => {
                setDateFrom(e[0] ? moment(e[0], "DD/MM/YYYY") : null);
                setDateTo(e[1] ? moment(e[1], "DD/MM/YYYY") : null);
              }}
            />
          </Col>
          <Col span={6}>
            <Row gutter={8} type="flex" justify="end" className="mb-2 mt-2">
              <Col>
                <Button
                  type="dashed"
                  onClick={() => fileInputRef.current.click()}
                >
                  <BiImport size={12} className="mr-2" />
                  Import
                </Button>
              </Col>
              <Col>
                <Button type="primary" onClick={downloadTemplate}>
                  <BiExport size={12} className="mr-2" />
                  Export Template
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        <Table
          bordered
          size="small"
          dataSource={data?.data.length > 0 ? data?.data : []}
          rowKey="row_id"
          loading={loading}
          scroll={{ x: "max-content" }}
          pagination={{
            current: page,
            pageSize: limit,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
            total: data?.data.length,
            showLessItems: true,
            size: "default",
            onChange: (currPage) => setPage(currPage),
          }}
        >
          <Table.Column title="No" dataIndex="row_id" align="left" />
          <Table.Column
            title="ประเภทสมาชิก"
            dataIndex="partner_type"
            align="left"
          />
          <Table.Column
            title="รหัสสมาชิก"
            dataIndex="partner_code"
            align="left"
          />
          <Table.Column
            title="ชื่อ - นามสกุล"
            dataIndex="partner_name"
            align="left"
          />
          <Table.Column
            title="วันที่คะแนนเข้าระบบ"
            dataIndex="document_date"
            align="left"
            render={(text) => text ? moment(text).format('DD/MM/YYYY HH:mm') : '-'}
          />
          <Table.Column
            title="รายละเอียด"
            dataIndex="description"
            align="left"
          />
          <Table.Column title="คะแนน RP" dataIndex="point" align="left" />
        </Table>
        <Modal
          title="ผลการนำเข้าข้อมูล"
          visible={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={[
            <Button key="export" onClick={exportFailList}>
              Export Fail List
            </Button>,
            <Button
              key="close"
              type="primary"
              onClick={() => {
                setIsModalVisible(false);
                reload();
              }}
              style={{ marginLeft: 8 }}
            >
              ตกลง
            </Button>,
          ]}
          width={800}
          zIndex={1080}
        >
          <Table
            bordered
            size="small"
            dataSource={resImportStatusData.map((item, index) => ({
              ...item,
              key: index,
            }))}
            pagination={{
              current: modalStatusPage,
              pageSize: pageSize,
              total: resImportStatusData.length,
              onChange: (page) => setModalStatusPage(page),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
              size: "default",
              showLessItems: false,
            }}
          >
            <Table.Column
              title="#"
              key="index"
              render={(_, __, index) =>
                (modalStatusPage - 1) * pageSize + index + 1
              }
            />
            <Table.Column title="รหัสสมาชิก" dataIndex="partner_code" />
            <Table.Column title="ชื่อ - นามสกุล" dataIndex="partner_name" />
            <Table.Column title="รายละเอียด" dataIndex="description" />
            <Table.Column title="คะแนน RP" dataIndex="point" />
            <Table.Column title="สถานะ" dataIndex="status" />
          </Table>
          <Row justify="space-between" className="mt-3">
            <Col>
              <span></span>
              <Text>
                <span role="img" aria-label="success">
                  ✅
                </span>{" "}
                สำเร็จ:{" "}
                {
                  resImportStatusData.filter((item) =>
                    item.status?.toLowerCase().includes("success")
                  ).length
                }{" "}
                รายการ{" | "}
                <span role="img" aria-label="fail">
                  ❌
                </span>{" "}
                ไม่สำเร็จ:{" "}
                {
                  resImportStatusData.filter((item) =>
                    item.status?.toLowerCase().includes("failed")
                  ).length
                }{" "}
                รายการ
              </Text>
            </Col>
          </Row>
        </Modal>
        <Modal
          title="ยืนยันการทำรายการ"
          visible={previewModalVisible}
          onCancel={() => setPreviewModalVisible(false)}
          width={800}
          zIndex={1080}
          footer={[
            <Button key="cancel" onClick={() => setPreviewModalVisible(false)}>
              ยกเลิก
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={isSubmitting}
              onClick={() => {
                setIsSubmitting(true);
                axios({
                  method: "post",
                  baseURL: URL_API,
                  url: `/point/rp/importRp`,
                  headers: { Authorization: "Bearer " + getToken() },
                  data: {
                    import_data: previewImportData,
                    sheet_name: sheetName,
                    file_name: fileName,
                  },
                  cancelToken: source.token,
                })
                  .then((res) => {
                    const responseData = res.data?.data || [];
                    setResImportStatusData(responseData);
                    setIsModalVisible(true);
                    setPreviewModalVisible(false);
                  })
                  .catch((err) => {
                    Modal.error({
                      title: "ผิดพลาด",
                      content: err.response?.data?.message || err.message,
                      okText: "ตกลง",
                      zIndex: 1080,
                    });
                  })
                  .finally(() => {
                    setIsSubmitting(false);
                  });
              }}
            >
              บันทึก
            </Button>,
          ]}
        >
          <Table
            bordered
            size="small"
            dataSource={previewImportData.map((item, idx) => ({
              ...item,
              key: idx.toString(),
            }))}
            rowKey="key"
            pagination={{
              current: importPage,
              pageSize: pageSize,
              total: previewImportData.length,
              onChange: (currPage) => setImportPage(currPage),
              size: "default",
              showLessItems: false,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
            }}
          >
            <Table.Column
              title="ลำดับ"
              key="index"
              render={(_, __, index) => (importPage - 1) * pageSize + index + 1}
            />
            <Table.Column title="รหัสสมาชิก" dataIndex="partner_code" />
            <Table.Column title="ชื่อ - นามสกุล" dataIndex="partner_name" />
            <Table.Column title="รายละเอียด" dataIndex="description" />
            <Table.Column title="คะแนน RP" dataIndex="point" />
          </Table>
        </Modal>
      </PanelBody>
    </Panel>
  );
};

export default Index;
